import { Sparkles, ChevronRight } from "lucide-react";
import BadgeClaimForm from "./BadgeClaimForm";

// The easiest badges you haven't earned yet — the quickest way to level up.
export default function WaysToLevelUp({ badges, pendingIds, claiming, onClaim, onSubmit, onCancel, submitting }) {
  if (badges.length === 0) {
    return (
      <div className="rounded-2xl bg-white border border-stone-100 p-5 text-center" data-testid="ways-to-level-up">
        <p className="text-2xl mb-1">🏆</p>
        <p className="font-medium text-sm text-[#1A1A1A]">You've earned every badge there is.</p>
        <p className="text-xs text-[#1A1A1A]/55 mt-1">Legend status. Steve owes you a coffee.</p>
      </div>
    );
  }
  return (
    <div className="rounded-2xl bg-white border border-stone-100 p-4 sm:p-5" data-testid="ways-to-level-up">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles className="w-4 h-4 text-[#C85A38]" strokeWidth={1.8} />
        <h3 className="font-serif text-lg text-[#1A1A1A]">Ways to level up</h3>
      </div>
      <p className="text-xs text-[#1A1A1A]/55 mb-3">Quickest points first. Tap one to claim it.</p>
      <ul className="space-y-2">
        {badges.map((b) => {
          const pending = pendingIds.includes(b.id);
          if (claiming === b.id) {
            return <li key={b.id}><BadgeClaimForm badge={b} onSubmit={onSubmit} onCancel={onCancel} submitting={submitting === b.id} /></li>;
          }
          return (
            <li key={b.id}>
              <button
                type="button"
                disabled={pending}
                onClick={() => onClaim(b.id)}
                className={`w-full flex items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition-colors ${pending ? "bg-amber-50 border-amber-200" : "bg-[#FBF7F1] border-stone-100 active:bg-[#F4ECE2]"}`}
                data-testid={`level-up-${b.id}`}
              >
                <span className="text-2xl w-9 text-center flex-shrink-0">{b.icon}</span>
                <span className="flex-1 min-w-0">
                  <span className="block font-medium text-sm text-[#1A1A1A]">{b.name}</span>
                  <span className="block text-[11px] text-[#1A1A1A]/55 leading-snug">{b.description}</span>
                </span>
                <span className="flex flex-col items-end flex-shrink-0">
                  <span className="text-sm font-semibold text-[#C85A38]">+{b.points}</span>
                  <span className={`text-[10px] ${pending ? "text-amber-700" : "text-[#1A1A1A]/40"}`}>{pending ? "Waiting for Steve" : "Claim"}</span>
                </span>
                {!pending && <ChevronRight className="w-4 h-4 text-[#1A1A1A]/25 flex-shrink-0" />}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
